export default "__VITE_ASSET__D2B_X5yp__"